import {
  responseSystemErrorList,
  failureSystemErrorList,
  requestSystemErrorList,
} from 'reactRedux/slices/systemErrorSlice/systemErrorSlice';
import Swal from 'sweetalert2';
import requestApi from 'utils/Request';
import { ERRORLOG_LIST } from 'utils/StaticApiEndpoints';

export const GetSystemErrorList = (payload) => async (dispatch) => {
  try {
    dispatch(requestSystemErrorList());
    const res = await requestApi.get(ERRORLOG_LIST, { params: payload });
    dispatch(responseSystemErrorList(res));
  } catch (error) {
    Swal.fire({
      icon: 'error',
      text: error?.message,
    });
    dispatch(failureSystemErrorList(error?.message));
  }
};
